import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Compass = createReactComponent("Compass", ["svg", defaultAttributes, [["circle", {
  cx: "12",
  cy: "12",
  r: "10",
  key: "14id60"
}], ["polygon", {
  points: "16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76",
  key: "aph1zg"
}]]]);
export default Compass;